export default __webpack_public_path__ + "images/SpeakersPhotos/Nuri_Demirci_Microsoft.jpg?2e93cebf";